import React, { useState } from "react";
import {
  greyColor,
  lightYellowColor,
  orangeColor,
  redColor,
  redOrangeColor,
  yellowColor,
} from "utils/common";
import { FilledDiamond } from "./FilledDiamond";

type RatingDiamondsProps = {
  value: number;
  onChange: (value: number) => void;
  size?: number;
  id: "general" | "client_service" | "product_images";
};

const RatingDiamonds: React.FC<RatingDiamondsProps> = ({ value, onChange, size = 40, id }) => {
  const [hoveredRating, setHoveredRating] = useState<number | null>(null);

  const getColorForRating = (rating: number) => {
    if (rating >= 0 && rating <= 1) return redColor;
    if (rating > 1 && rating <= 2) return redOrangeColor;
    if (rating > 2 && rating <= 3) return orangeColor;
    if (rating > 3 && rating <= 4) return yellowColor;
    if (rating > 4 && rating <= 5) return lightYellowColor;
    return greyColor;
  };

  return (
    <div className="flex gap-0">
      {[1, 2, 3, 4, 5].map((num) => (
        <div
          id={`${id}_rating_yakouta_${num}`}
          key={num}
          className="cursor-pointer"
          onClick={() => onChange(num)}
          onMouseEnter={() => setHoveredRating(num)}
          onMouseLeave={() => setHoveredRating(null)}
        >
          <FilledDiamond
            filled={num <= (hoveredRating ?? value)}
            color={getColorForRating(hoveredRating ?? value)}
            size={size}
          />
        </div>
      ))}
    </div>
  );
};

export default RatingDiamonds;
